
const { ccclass, property } = cc._decorator;

@ccclass
export default class BetItem extends cc.Component {
    @property(cc.Label)
    countLab:cc.Label = null

    @property(cc.Sprite)
    bgSpr:cc.Sprite = null

    @property(cc.SpriteAtlas)
    betAtlas:cc.SpriteAtlas = null

    onload(){

    }

    updateShow(betNum:number){
        let str = ""
        if (betNum > 0 && betNum < 10)
        {
            str = "public_bet_5"
        }
        else if (betNum >= 10  && betNum < 20){
            str = "public_bet_10"
        }
        else if (betNum >= 20  && betNum < 50){
            str = "public_bet_20"
        }
        else if (betNum >= 50  && betNum < 100){
            str = "public_bet_100"
        }
        else if (betNum >= 100  && betNum < 200){
            str = "public_bet_200"
        }
        else if (betNum >= 200  && betNum < 500){
            str = "public_bet_500"
        }
        else if (betNum >= 500  && betNum < 1000){
            str = "public_bet_1000"
        }
        else if (betNum >= 1000  && betNum < 2000){
            str = "public_bet_2000"
        }
        else if (betNum >= 2000  && betNum < 5000){
            str = "public_bet_5000"
        }
        else if (betNum >= 5000  && betNum < 10000){
            str = "public_bet_10000"
        }
        else if (betNum >= 10000  && betNum < 20000){
            str = "public_bet_20000"
        }
        else if (betNum >= 20000){
            str = "public_bet_50000"
        }
        this.bgSpr.spriteFrame = this.betAtlas.getSpriteFrame(str)
        this.countLab.string = betNum.toString()
    }

}